// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"2062d5bb","205":"fbd10ebf","484":"dae354b3","551":"69d13178","559":"d1009c3a","828":"ae55c774","849":"3debecd6","869":"88b6548e","971":"8a422f9a","974":"fb9f14b0"}[chunkId] + ".chunk.js";
};